export enum PatientFormAssignmentStatus {
  PENDING = 'PENDING',
  ASSIGNED = 'ASSIGNED',
  IN_PROGRESS = 'IN_PROGRESS',
  COMPLETED = 'COMPLETED',
  EXPIRED = 'EXPIRED',
  CANCELLED = 'CANCELLED',
}

type OMITTED_VALUES = 'createdAt' | 'updatedAt' | 'form' | 'patient' | 'assignedByUser' | 'filledByUser';

export interface FormRef {
  id: string;
  identifier: string;
  name: string;
  version: number;
}

export interface PatientRef {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface UserRef {
  id: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface PatientFormAssignmentModel {
  id: string;
  formId?: string;
  patientId: string;
  assignedBy?: string;
  expiresAt: string;
  status?: PatientFormAssignmentStatus;
  responseData?: any;
  progress?: number;
  fillingMethod?: string;
  filledByUserId?: string;
  assignedAt?: string;
  firstAccessedAt?: string;
  completedAt?: string;
  accessToken?: string;

  createdAt: string;
  updatedAt: string;

  form?: FormRef;
  patient?: PatientRef;
  assignedByUser?: UserRef;
  filledByUser?: UserRef;
}

export interface PatientFormAssignmentPageModel {
  data: PatientFormAssignmentModel[];
  total: number;
  page: number;
  limit: number;
}

export const EMPTY_FORM_ASSIGNMENT_PAGE_MODEL: PatientFormAssignmentPageModel = {
  data: [],
  total: 0,
  page: 1,
  limit: 10,
};

export interface CreatePatientFormAssignmentModel extends Omit<PatientFormAssignmentModel, 'id' | OMITTED_VALUES> {
  durationSeconds: number;
}

export interface UpdatePatientFormAssignmentModel extends Partial<Omit<PatientFormAssignmentModel, OMITTED_VALUES>> { }
